import { useEffect, useState, useRef } from "react";
import { useParams, useSearchParams } from "react-router";
import type { SoundResponse } from "@wizard-sounds/shared";
import { api } from "@/lib/api";

export function TriggerMode() {
  const { slug } = useParams<{ slug: string }>();
  const [searchParams] = useSearchParams();
  const [sound, setSound] = useState<SoundResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;

    api.sounds
      .get(slug)
      .then((data) => {
        if (cancelled) return;
        setSound(data);
        const audio = new Audio(data.audio_url);
        audioRef.current = audio;

        audio.addEventListener("canplaythrough", () => {
          if (cancelled) return;
          audio.play();
          setPlaying(true);
          api.sounds.play(data.id).catch(() => {});
        });

        audio.addEventListener("ended", () => {
          setPlaying(false);
          if (searchParams.get("close") === "1") {
            window.close();
          }
        });

        audio.addEventListener("error", () => {
          if (cancelled) return;
          setError("Failed to load audio");
        });
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      });

    return () => {
      cancelled = true;
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
        audioRef.current = null;
      }
    };
  }, [slug]);

  return (
    <div className="flex h-screen items-center justify-center bg-transparent">
      {error ? (
        <p className="text-sm text-ember">{error}</p>
      ) : playing ? (
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 animate-pulse rounded-full bg-spark" />
          <span className="text-sm text-fog">
            {sound?.title}
          </span>
        </div>
      ) : (
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-spark border-t-transparent" />
      )}
    </div>
  );
}
